import {atom} from "recoil";
import {SelectElementModelFE} from "../api/types/generic";
import {ExceptionListSelectFE, FormSearchExceptionListModel} from "../api/types/exceptionList";

export const exceptionListsAtom = atom<SelectElementModelFE[]>({
    key: "exceptionListsAtom",
    default: []
});
export const exceptionListSelectListAtom = atom<ExceptionListSelectFE[]>({
    key: "exceptionListSelectListAtom",
    default: []
});

export const initialExceptionListFilters: FormSearchExceptionListModel = {
    listName: "",
    commercialCategoryId: null,
    commercialSegmentId: null,
    from: null,
    to: null,
    dealers: [],
    legalEntities: []
};
export const exceptionListFiltersAtom = atom<FormSearchExceptionListModel>({
    key: "exceptionListFiltersAtom",
    default: initialExceptionListFilters
});